module.exports = __webpack_public_path__ + "img/talk.7059c0b3.png";